export const sectionImages = {
  hero: '/pictures/webp/homepage/S1.webp',
  project: '/pictures/webp/homepage/S2.webp',
  gites: '/pictures/webp/homepage/S3.webp',
  orchards: '/pictures/webp/homepage/S4.webp',
  forest: '/pictures/webp/homepage/S5.webp',
}